<template>
  <div class="app-container">
    <el-tabs v-model="defaultTab" >
      <el-tab-pane label="草地贪夜蛾发生预测" name="first" :key="'first'">
        <helloWorld ></helloWorld>
      </el-tab-pane>
      <el-tab-pane label="田间调查信息上报" name="second" :key="'second'">
        <fieldSurveyPage ></fieldSurveyPage>
      </el-tab-pane>
      <el-tab-pane label="性(食)诱剂信息上报" name="third" :key="'third'">
        <sexTrapPage ></sexTrapPage>
      </el-tab-pane>
      <el-tab-pane label="测报灯信息上报" name="forth" :key="'forth'">
        <lampTrapPage ></lampTrapPage>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
  import FieldSurvey from './FieldSurvey.vue'
  import LampTrap from './LampTrap.vue'
  import SexTrap from './SexTrap.vue'
  import HelloWorld from './HelloWorld.vue'

    export default {
        name: 'AccumulatedTemperaturePrediction',
        data() {
            return {
              defaultTab: 'first',
    }
  },
  mounted(){
  },
  components: {
    fieldSurveyPage: FieldSurvey,
    lampTrapPage: LampTrap,
    sexTrapPage: SexTrap,
    helloWorld: HelloWorld,
  },
  methods: {


  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

</style>
